module.exports = __webpack_public_path__ + "assets/img/17_995_big.1730c9b7.jpg";